/*
 *   File : reject-modal.js
 *   Author : https://evoqins.com
 *   Description : Reject modal component
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea } from '../FormElements';


const RejectModal = (props) => {

    const [note, setNote] = useState("");
    const [noteError, setNoteError] = useState("");

    useEffect(() => {
        setNoteError("");
    }, [note]);

    useEffect(() => {
        if (props.status === true) {
            _handleCloseModal();
        }
    }, [props.status]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("reject-modal-close");
        button.click();
        props.handleClose();
    };

    // handle confirm 
    const _handleConfirm = () => {
        if (note.trim().length === 0) {
            toast.dismiss();
            setNoteError('Please enter the reason of rejection ')
        } else {
            props.handleConfirm(note);
            // _handleCloseModal();
        }
    };

    return (
        <div className="modal fade"
            id="reject-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="RejectModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='reject-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            Reject Bank Verification Request
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-1 padding-32px-lr'>
                        <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                            Are you sure you want to reject the bank verification for:
                            Customer name: <span className='e-font-weight-600'>{props.data.name}</span> <br />
                            A/C No: <span className='e-font-weight-600'>{props.data.account_number}</span>
                        </p>

                        <div className='pt-3'>
                            <CustomTextArea label="Reason"
                                placeholder="Enter reason for rejection"
                                type="text"
                                value={note}
                                error={noteError}
                                required={true}
                                className="w-100 "
                                borderStyle="e-border-0-5px-arsenic"
                                handleChange={(e) => setNote(e)} />
                        </div>
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                        <>
                            <SecondaryButton name="Cancel"
                                paddingBlock="py-3 padding-54px-lr"
                                onClick={_handleCloseModal} />
                            <PrimaryButton name="Confirm"
                                paddingBlock="padding-64px-lr py-3"
                                loader={props.loader}
                                onClick={_handleConfirm} />
                        </>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default RejectModal;
